const state = () => ({
  pinnedDepartments: []
})

const getters = {
  isPinned: (state) => (departmentId) => {
    return state.pinnedDepartments.includes(departmentId)
  }
}

const mutations = {
  setPinnedDepartments(state, pinnedDepartments) {
    state.pinnedDepartments = pinnedDepartments
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}